import { ALERT_SEVERITY, ERROR_MESSAGES, ROLE_TYPE } from '../constants';
import { setGlobalMessage, setLoading, clearGloablMessage } from './app';
import { setAuthUser, clearAuthUser } from './auth';
import { Catch } from './api_exception';
import { useHistory } from 'react-router';
import { ROUTES_PATH_CONFIG } from 'eebac/config/routes';
import { userSignOut } from 'eebac/config/configureStore';

const BASE_PATH = 'SIGNIN';

export const SET_SIGNIN_DATA = `${BASE_PATH}/SET_SIGNIN_DATA`;
export const CLEAR_SIGNIN_DATA = `${BASE_PATH}/CLEAR_SIGNIN_DATA`;
export const SET_SIGNIN_AS_SUBUSER = `${BASE_PATH}/Set_SIGNIN_AS_SUBUSER`;


export const setSigninData = data => ({
    type: SET_SIGNIN_DATA,
    data
});

export const clearSigninData = () => ({
    type: CLEAR_SIGNIN_DATA,
});

export const setSignInAsSubuser = (isSubuser) => ({
    type: SET_SIGNIN_AS_SUBUSER,
    isSubuser
});

export const signIn = () =>
    (dispatch, getState, client) => {
        dispatch(clearGloablMessage());
        dispatch(setLoading(true));

        let appState = getState();
        let state = appState.SIGNIN_DATA;

        let authLoginPath = '/auth/login';
        if (state.signinAsSubuser) {
            authLoginPath = "/company_user/login"
        }

        client.post(authLoginPath, {
            username: state.email,
            password: state.password
        }).then(res => res.data).then(result => {
            // Debug logs to help diagnose login problems in browser console
            try {
                console.log('[SIGNIN] request:', authLoginPath, { username: state.email });
                console.log('[SIGNIN] response:', result);
            } catch (e) { }

            dispatch(setLoading(false));
            if (result.token) {
                //dispatch(setGlobalMessage(result.token, ALERT_SEVERITY.SUCCESS));
                dispatch(clearSigninData());
                dispatch(setAuthUser(result.user, result.token, result.rt));
            } else {
                dispatch(setGlobalMessage(result.errorMessage ? result.errorMessage :
                    ERROR_MESSAGES.SERVER_FAULT,
                    ALERT_SEVERITY.ERROR));
            }
        }).catch(error => {
            // Log the error so it's visible in DevTools
            try {
                console.error('[SIGNIN] request failed:', authLoginPath, error);
            } catch (e) { }

            dispatch(setLoading(false));
            dispatch(setGlobalMessage(ERROR_MESSAGES.SERVER_FAULT,
                ALERT_SEVERITY.ERROR));
        });
    }

export const signOut = () =>
    (dispatch, getState, client) => {
        let authData = getState().AUTH;
        const user = authData.user ?
            authData.user : { role: "none" };

        dispatch(clearGloablMessage());
        const history = useHistory();
        let logoutPath = '/auth/logout';
        if (user.role === ROLE_TYPE.COMPANY_CONTRACTS ||
            user.role === ROLE_TYPE.COMPANY_HR) {
            logoutPath = '/company_user/logout';
        }

        client.get(logoutPath).
            then(res => res.data).then(result => {
                dispatch(userSignOut());
                if (!result.isSuccess) {
                    dispatch(setGlobalMessage(result.errorMessage ? result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT,
                        ALERT_SEVERITY.ERROR));
                }

                setTimeout(() => {
                    window.location = ROUTES_PATH_CONFIG.APP.redirect_signin;
                }, 1000);

            }).catch(error => {
                dispatch(userSignOut());
                Catch(error, dispatch);
                setTimeout(() => {
                    window.location = ROUTES_PATH_CONFIG.APP.redirect_signin;
                }, 1000);
            });
    }

const initialState = {
    errorMessage: '',
    email: '',
    emailError: '',
    password: '',
    passwordError: '',
    rememberMe: true,
    signingIn: false,
    signingOut: false,
    signinAsSubuser: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_SIGNIN_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case SET_SIGNIN_AS_SUBUSER:
            return {
                ...initialState,
                signinAsSubuser: action.isSubuser
            }
        case CLEAR_SIGNIN_DATA:
            return initialState;
        default:
            break;
    }

    return state;
}